import { render, staticRenderFns } from "./PaymentChip.vue?vue&type=template&id=ffac3934&scoped=true&"
import script from "./PaymentChip.vue?vue&type=script&lang=ts&"
export * from "./PaymentChip.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentChip.vue?vue&type=style&index=0&id=ffac3934&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffac3934",
  null
  
)

export default component.exports